<template>
  <div>
    <v-card>
      <v-card-title><span class="table-card-title">Cupons gerados</span></v-card-title>
      <paginated-data-table :headers="headers" :query="query" :custom-items-per-page="10" queryName="coupons" :queryVariables="queryVariables">
        <template v-slot:item="{ item }">
          <tr>
            <td class="nowrap-row">
              <span class="sized-span">{{ item.id }}</span>
            </td>
            <td class="nowrap-row">
              {{ item.unit.name }}
            </td>
            <td class="nowrap-row">
              {{ item.revenue | localeString(2) | currency }}
            </td>
            <td>
              {{ item.products_count | localeString(2) }}
            </td>
            <td>
              {{ item.total_products_quantity | localeString(2) }}
            </td>
            <td>
              {{ item.purchased_at | date({ fmtIn: 'yyyy-MM-dd', fmtOut: 'dd/MM/yyyy' }) }}
            </td>
            <td>
              <span class="link" @click="showCoupon(item)">Ver cupom</span>
            </td>
          </tr>
        </template>
      </paginated-data-table>
    </v-card>
    <coupon-modal v-model="showCouponModal" :coupon="selectedCoupon" :client-id="userId" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { QUERY_GET_COUPONS } from '@/modules/clientes/detalhes-cliente/graphql'
export default {
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
    CouponModal: () => import('@/modules/clientes/detalhes-cliente/views/components/CouponModal.vue'),
  },
  props: {
    userId: String,
  },
  data: () => ({
    showCouponModal: false,
    selectedCoupon: {},
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    query() {
      return QUERY_GET_COUPONS
    },
    queryVariables() {
      return {
        user: this.userId,
        initialDate: this.stateFilters.data?.[0],
        finalDate: this.stateFilters?.data?.[1],
        units: this.stateFilters?.units,
        units_configuration: this.stateFilters?.unitsConfiguration,
      }
    },
    headers() {
      return [
        {
          text: 'ID do cupom',
          value: 'id',
          width: '15%',
        },
        {
          text: 'Loja',
          value: 'unit.name',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Faturamento',
          value: 'revenue',
          width: '12%',
        },
        {
          text: 'Número de produtos',
          value: 'products_count',
          width: '18%',
        },
        {
          text: 'Itens na cesta',
          value: 'total_products_quantity',
          width: '15%',
        },
        {
          text: 'Data',
          value: 'purchased_at',
          width: '15%',
        },
        {
          text: '',
          sortable: false,
          width: '10%',
        },
      ]
    },
  },
  methods: {
    showCoupon(coupon) {
      this.selectedCoupon = coupon
      this.showCouponModal = true
    },
  },
}
</script>

<style lang="scss">
.sized-span {
  display: block;
  max-width: 330px;
  word-wrap: break-word;
}
</style>
